import {useContext} from 'react'
import {CustomerReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import CustomerGroupReportRow from './CustomerGroupReportRow'
import {parseCustomerGroupReportRow} from '../../parsings'
import {CUSTOMER_GROUP_REPORT_COLUMNS} from '../../utils'
import CustomerGroupReportsHeader from '../header/CustomerGroupReportsHeader'
import {formatPrice} from '../../../../utils/common'

const CustomerGroupReportTable = () => {
  const {
    customerGroupData,
    isCustomerGroupLoading,
    onCustomerGroupSortingChange,
    customerGroupFilters,
  } = useContext(CustomerReportContext)

  return (
    <div className='card border mb-10'>
      <div className='card-body p-7'>
        <CustomerGroupReportsHeader />
        <DynamicTable
          data={customerGroupData}
          sortableColumns={CUSTOMER_GROUP_REPORT_COLUMNS}
          loading={isCustomerGroupLoading}
          TableRow={CustomerGroupReportRow}
          noDataMessage='No customer group reports found'
          filters={customerGroupFilters}
          onSortingChange={onCustomerGroupSortingChange}
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          rowParsingFunction={parseCustomerGroupReportRow}
          tableFooter={({columnTotals}: any) => (
            <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
              <tr>
                <td>TOTAL</td>
                <td>{columnTotals.total_order_count}</td>
                <td>{formatPrice(columnTotals.total_discount, false)}</td>
              </tr>
            </tfoot>
          )}
        />
      </div>
    </div>
  )
}

export default CustomerGroupReportTable
